import { render, staticRenderFns } from "./FechaTemplate.vue?vue&type=template&id=55f3504f&scoped=true"
import script from "./FechaTemplate.vue?vue&type=script&lang=js"
export * from "./FechaTemplate.vue?vue&type=script&lang=js"
import style0 from "./FechaTemplate.vue?vue&type=style&index=0&id=55f3504f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55f3504f",
  null
  
)

export default component.exports